
<ksuite-card
    [isSuggested]="true"
    [compact]="true"
>
    <div class="row">
        <div class="col-12 col-sm-9">
            <div class="checkbox-wrapper">
            <mat-checkbox [checked]="isChecked" [disabled]="isDisabled || isLoading" color="primary" (change)="toggleCheckbox($event)">
                <span class='icon icon-product-renewal-warranty icon-size-34 primary'></span>
            </mat-checkbox>
                <div class="text-block">
                    <strong class="margin-bottom-5">Renewal Warranty</strong>
                    <div>
                        <span>{{'La solution qui sert a vous premunir de l\'expiration involontaire de vos services.' | transloco}}</span>&nbsp;
                        <a [href]="this.renewalWarrantyInfoLink" target="_blank" class="blue link">{{'En savoir plus' | transloco}}</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-sm-3 top-xs-30">
            <div *ngIf="!!renewalWarranty && !isLoading" class="price-wrapper">
                <ng-container *ngIf="activationPrice.amountVAT !== renewPrice.amountVAT; else samePrice">
                    <span [innerHTML]="activationPrice | mycurrency">
                    </span>
                    <span [innerHTML]="'puis $price$ au renouvellement' | transloco: { price: renewPrice | mycurrency }">
                    </span>
                </ng-container>
                <ng-template #samePrice>
                    <span [innerHTML]="activationPrice | mycurrency"></span>
                </ng-template>
            </div>
            <div *ngIf="!renewalWarranty || isLoading" class="price-wrapper price-wrapper--loader">
                <app-skeleton-loader [contentWidth]="'100%'"></app-skeleton-loader>
                <app-skeleton-loader [contentWidth]="'100%'"></app-skeleton-loader>
            </div>
        </div>
    </div>
</ksuite-card>
